<template>
    <div class="row-min-space">
        <!-- :label="field.label" -->
        <b-form-group
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
            ><label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label">({{ field.urduLabel }})</span
            ></label> -->
            <div class="row profile-setup remove-form-group">
                <div class="col-md-5 mb-20 dialling-code-field">
                    <isd-code
                        v-validate="{
                            required: true,
                        }"
                        :data-segment-id="dataSegmentId"
                        :field="{
                            association: 'countries',
                            type: 'isd-code',
                            isLocked: true,
                            isRequired: field.isRequired,
                            label: 'Dialing code',
                            placeholder: 'Dialing code',
                            isDisabled: field.isDisabled,
                            options: [],
                            key: selectKey()
                        }"
                        text-field="isdCodeTitle"
                        value-field="isdCode"
                        :multiple="false"
                        name="Dialing Code"
                        :class="{
                            'is-invalid': errors.has('Dialing Code'),
                        }"
                    ></isd-code>
                </div>
                <div class="col-md-7">
                    <b-form-input
                        v-model="model"
                        v-validate="{
                            required: field.isRequired,
                            max: 10,
                            min: 10,
                            regex: /^([0-9]*)$/,
                        }"
                        type="tel"
                        maxLength="10"
                        :disabled="loading || field.isDisabled"
                        placeholder="Enter phone number (300XXXXXXX)"
                        data-vv-name="phone number"
                        :class="{
                            'is-invalid': errors.has('phone number'),
                        }"
                    ></b-form-input>
                    <!-- @input="isPmdaFormValid" -->
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import IsdCode from './IsdCode'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IsdCode,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
        selectedLanguage: {
            type: String,
            default: 'en',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        urduLabel() {
            if (
                this.$store.state.registration.form.languageOption == 'urd' 
            ) {
                return true
            } else {
                return false
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
     
    }, // End of Component > computed
    watch: {
        selectedLanguage(value) {
            if (value == 'en') {
                this.field.label = 'Phone Number'
            } else {
                this.field.label = 'فون نمبر'
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        isPmdaFormValid() {
            this.$store.commit('updateField', {
                key: 'pmdaForm.valid',
                value: false,
            })
        },
        selectKey(){
            if (this.field.key == 'contactInfo.phoneNumber'){
                return 'contactInfo.isdCode'
            } else {
                return 'contactInfo.whatsappIsdCode'
            }
            
        }
    }, // End of Component > mounted
}
</script>
